import React from 'react';
import {
  Button,
  Row,
  Col,
  Modal,
  List,
  Popconfirm,
  Typography,
  Input,
  Form,
  Select
} from 'antd';
import {
  applicationStatus,
  editableFields,
  restrictedFieldNames
} from '../constant';
import EditFormField from './EditFormField';
import { getCancellationData } from '../utils';

const { Text } = Typography;
const { Option } = Select;

const StartCommunityApplicationModal = ({
  activeApplication,
  clearActiveApplication,
  onStatusSubmit,
  isStatusLoading,
  renderApplicationStatusTag,
  statusForm,
  updateReviewersNote,
  updateApplicationField
}) => {
  const applicationKeys = Object.keys(activeApplication ?? {});
  const cancellationData = getCancellationData({
    application: activeApplication
  });

  const renderCtas = () => {
    return (
      <Form form={statusForm}>
        <Row>
          <Col span={24}>
            <Form.Item
              name="reviewerNotes"
              label="Notes (Optional)"
              initialValue={activeApplication?.reviewerNotes}>
              <Input.TextArea placeholder="Add notes..." />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          {[applicationStatus.MAYBE, applicationStatus.PENDING].includes(
            activeApplication?.status
          ) ? (
            <Row gutter={8}>
              <Col>
                <Popconfirm
                  key="approve"
                  title="Are you sure to approve?"
                  onConfirm={async () =>
                    await onStatusSubmit({
                      status: applicationStatus.APPROVE
                    })
                  }
                  okText="Yes"
                  cancelText="No">
                  <Button type="primary" loading={isStatusLoading}>
                    Approve
                  </Button>
                </Popconfirm>
              </Col>
              {activeApplication?.status !== applicationStatus.MAYBE && (
                <Col>
                  <Popconfirm
                    key="approve"
                    title="Are you sure to submit as maybe??"
                    onConfirm={async () =>
                      await onStatusSubmit({
                        status: applicationStatus.MAYBE
                      })
                    }
                    okText="Yes"
                    cancelText="No">
                    <Button type="ghost" loading={isStatusLoading}>
                      Maybe
                    </Button>
                  </Popconfirm>
                </Col>
              )}

              <Col>
                <Popconfirm
                  key="reject"
                  title="Are you sure to reject?"
                  onConfirm={async () =>
                    await onStatusSubmit({
                      status: applicationStatus.REJECT
                    })
                  }
                  okText="Yes"
                  cancelText="No">
                  <Button type="danger" loading={isStatusLoading}>
                    Reject
                  </Button>
                </Popconfirm>
              </Col>
            </Row>
          ) : (
            <Row gutter={8}>
              <Button
                key="cancel"
                onClick={clearActiveApplication}
                loading={isStatusLoading}>
                Close
              </Button>
            </Row>
          )}
          <Row>
            <Popconfirm
              key="save"
              title="Are you sure to save?"
              onConfirm={updateReviewersNote}
              okText="Yes"
              cancelText="No">
              <Button loading={isStatusLoading}>Save Notes</Button>
            </Popconfirm>
          </Row>
        </Row>
      </Form>
    );
  };

  const renderFields = ({ fieldName, fieldValue }) => {
    const shouldShow = !restrictedFieldNames.includes(fieldName);
    const isEditable = editableFields.includes(fieldName);

    if (!shouldShow) return;

    if (typeof fieldValue === 'string' || typeof fieldValue === 'number')
      return isEditable ? (
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Text strong>{fieldName}</Text>
          </Col>
          <Col span={18}>
            <EditFormField
              value={fieldValue}
              name={fieldName}
              onSubmit={updateApplicationField}
              isLoading={isStatusLoading}
            />
          </Col>
        </Row>
      ) : (
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Text strong>{fieldName}</Text>
          </Col>
          <Col span={18}>{fieldValue}</Col>
        </Row>
      );

    if (typeof fieldValue === 'object' && Array.isArray(fieldValue))
      return (
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Text strong>{fieldName}</Text>
          </Col>
          <Col span={18}>
            <List
              size="small"
              bordered
              dataSource={fieldValue}
              renderItem={(item) => (
                <List.Item>{JSON.stringify(item)}</List.Item>
              )}
            />
          </Col>
        </Row>
      );
  };

  return (
    <Modal
      destroyOnClose={true}
      title={activeApplication?.fullName}
      visible={!!activeApplication}
      footer={null}
      onCancel={clearActiveApplication}
      centered
      afterClose={() => statusForm.resetFields()}>
      {applicationKeys?.map((fieldName) =>
        renderFields({
          fieldName,
          fieldValue: activeApplication?.[fieldName]
        })
      )}
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Text strong>Current Status</Text>
        </Col>
        <Col span={18}>
          {renderApplicationStatusTag({
            text: activeApplication?.status,
            status: activeApplication?.status
          })}
        </Col>
      </Row>
      {cancellationData?.isCancelled && (
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <Text strong>Cancellation Reason</Text>
          </Col>
          <Col span={18}>{cancellationData?.cancellationReason}</Col>
        </Row>
      )}
      {renderCtas()}
    </Modal>
  );
};

export default StartCommunityApplicationModal;
